import { SaveButton } from "components/Buttons"
import { URL_PATHS } from "constants/index"
import React from "react"
import { withRouter, generatePath } from "react-router-dom"
import { Row, Col, Card, CardBody, Button, Table, CardFooter } from "reactstrap"

const CommentBoardCard = ({ data, history, eventId }) => {
  return (
    <Col xl={4}>
      <Card style={{ minHeight: "415px" }}>
        <CardBody className="pb-0">
          <Row>
            <Col>
              <h5>Comment Board</h5>
            </Col>
          </Row>
          <Row className="mt-1">
            <div className="table-responsive p-0">
              <Table className="align-middle table-nowrap">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div>
                          <p className="font-size-14 mb-1">{item?.label}</p>
                        </div>
                      </td>
                      <td>
                        <div>
                          <p
                            className="font-size-14 mb-0"
                            style={{ color: "-webkit-link" }}
                          >
                            <Button
                              type="button"
                              color="link"
                              className="btn-sm btn-rounded"
                              onClick={() =>
                                history.push(
                                  generatePath(
                                    URL_PATHS.COMMENT_BOARD_REPORTS,
                                    {
                                      event_id: eventId,
                                      feature_id: item?.id,
                                    }
                                  )
                                )
                              }
                            >
                              View
                            </Button>
                          </p>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Row>
        </CardBody>
        <CardFooter style={{ background: "white" }} className="pt-0">
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color={"primary"}
                size="sm"
                content="View More"
                onClick={() => {
                  history.push(
                    generatePath(URL_PATHS.COMMENT_BOARD_LIST, {
                      event_id: eventId,
                    })
                  )
                }}
              />
            </Col>
          </Row>
        </CardFooter>
      </Card>
    </Col>
  )
}

export default withRouter(CommentBoardCard)
